import { BaseFilter, Entity, SchoolContentSectionType } from '@axl/accel-framework/models';
import { observable, computed } from 'mobx';
import moment from 'moment-timezone';

export class SchoolContentItemFavorite extends Entity {
    constructor(item?: Partial<SchoolContentItemFavorite>) {
        super(item);
        if (item) this.update(item);
    }

    @observable sectionType: SchoolContentSectionType;
    @observable title: string;
    @observable courseId: string | null = null;
    @observable courseTitle: string | null = null;
    @observable courseItemId: string | null = null;
    @observable libraryId: string | null = null;
    @observable libraryTitle: string | null = null;
    @observable libraryItemId: string | null = null;
    @observable createdDate: moment.Moment;

    @computed get itemId(): string {
        return (this.sectionType == SchoolContentSectionType.Library
            ? this.libraryItemId
            : this.courseItemId) ?? '';
    }

    @computed get sourceTitle(): string {
        return (this.sectionType == SchoolContentSectionType.Library
            ? this.libraryTitle
            : this.courseTitle) ?? '';
    }

    static fromJson(json: any): SchoolContentItemFavorite {
        return new SchoolContentItemFavorite({
            ...json,
            createdDate: json.createdDate ? moment(json.createdDate) : undefined
        });
    }
}

export class SchoolContentItemFavoriteFilter extends BaseFilter<SchoolContentItemFavorite> {
    constructor(filter?: Partial<SchoolContentItemFavoriteFilter>) {
        super();
        if (filter) this.update(filter);
    }

    id?: string;
    sectionType?: SchoolContentSectionType;
    courseId?: string;
    courseItemId?: string;
    libraryId?: string;
    libraryItemId?: string;

    update(changes: Partial<SchoolContentItemFavoriteFilter>) {
        super.update(changes);
    }
}
